import {Component, Input, OnInit} from '@angular/core';
import {ConstsHelper} from '../../../../../helpers/consts.helper';
import {PaymentDetailsInterface} from '../../../models/payment-details.interface';
import {LineInterface} from '../../../../lines/models/line.interface';

@Component({
  selector: 'app-unblock-line',
  templateUrl: './unblock-line.component.html',
  styleUrls: ['./unblock-line.component.css'],
  standalone: false
})
export class UnblockLineComponent implements OnInit {

  @Input()
  selectedLine: LineInterface;

  paymentDetailsInterface = {
    errorMessage: ConstsHelper.ERROR_MESSAGE_UNBLOCK_LINE,
    redirectLink: null,
    procedureCode: ConstsHelper.PROCEDURE_UNBLOCK_LINE,
    type: 'deblocage',
    procedureType: null,
    externalId: null,
    selectedLine: null,
    payload: {},
    amount: 75
  } as PaymentDetailsInterface;
  constructor() { }

  ngOnInit() {
    this.paymentDetailsInterface.payload = {phoneNumber: this.selectedLine.phoneNumber};
    this.paymentDetailsInterface.externalId = this.selectedLine.phoneNumber;
    this.paymentDetailsInterface.selectedLine = this.selectedLine;
  }

}
